import toast from "react-hot-toast";

export const showGenericError = () => {
  toast.error("Something went wrong, please try again");
};

export const showSuccessNotification = (message) => {
  toast.success(message, {
    style: {
      fontFamily: '"Lato", sans-serif',
      fontSize: "14px",
      padding: "8px 16px",
      backgroundColor: "#10B981",
      color: "#fff",
    },
    // Optional: you can add these for better visual hierarchy
    iconTheme: {
      primary: "#10B981", // Tailwind emerald-500
      secondary: "white",
    },
  });
};

export const showExportNotification = () => {
  toast.success(
    "We're preparing your CSV. You'll receive an email with a download link valid for 24 hours.",
    {
      duration: 10000, // 8 seconds (default is 4000)
      style: {
        fontFamily: '"Lato", sans-serif',
        fontSize: "14px",
        padding: "8px 16px",
        backgroundColor: "#10B981",
        color: "#fff",
      },
      // Optional: you can add these for better visual hierarchy
      iconTheme: {
        primary: "#10B981", // Tailwind emerald-500
        secondary: "white",
      },
    }
  );
};

export const showErrorNotification = (message) => {
  toast.error(message, {
    style: {
      fontFamily: '"Lato", sans-serif',
      fontSize: "14px",
      padding: "8px 16px",
      backgroundColor: "#EF4444", // Tailwind red-500
      color: "#fff",
      borderLeft: "4px solid #DC2626", // Tailwind red-600 for accent
      borderRadius: "4px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      minWidth: "300px",
    },
    iconTheme: {
      primary: "#fff",
      secondary: "#EF4444",
    },
  });
};

export const showErrorNotificationWithLink = (message, onSuccess) => {
  toast.error((t) => {
    return (
      <div
        onClick={() => {
          onSuccess();
          toast.dismiss(t.id);
        }}
      >
        {message}
      </div>
    );
  });
};
